
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightRainShowersNightColour as ObiLightRainShowersNightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-light-rain-showers-night-colour.js';
 
 
 

 
 export const ObiLightRainShowersNightColour = createComponent({
   react: React,
   tagName: 'obi-light-rain-showers-night-colour',
   elementClass: ObiLightRainShowersNightColourElement,
   events: {
     
   }
  });
 
 